<template>
  <div class="round-sl__holder" v-if="windowWidth > 780">
    <div
      class="round-sl"
      :style="{
        width: `${circleSize * 1.35}px`,
        height: `${circleSize * 1.35}px`,
      }"
    >
      <div class="round-sl__elements">
        <div v-for="(coffee, index) in list" :key="index + '-l'">
          <div
            v-if="index !== list.length - 1"
            class="round-sl__line round-sl__line--space"
            :style="calcTransformSpaceLineShift(index)"
          ></div>
          <div
            class="round-sl__line round-sl__line--mark"
            :style="calcTransformMarkLineShift(index)"
          ></div>
        </div>
        <div
          v-for="(coffee, index) in list"
          :key="index"
          class="round-sl__item-holder"
          :style="calcTransformShift(index)"
        >
          <div class="round-sl__item">
            <div class="round-sl__prcent">
              <big>{{ coffee.value || 0 }}</big
              ><sup>%</sup>
            </div>
            <div class="round-sl__name">
              <span>{{ coffee.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Steps from '@/class/Steps';
import Round from '@/class/Round';
import { NavigationDirection } from '@/models/navigation-direction';
import { RoundDirection } from '@/models/round-direction';

export default {
  methods: {
    round(index) {
      const count = this.list.length < 6 ? 6 : this.list.length;
      const baseAngle = this.list.length < 15 ? Math.PI / 2 : Math.PI;
      const round = {
        count,
        radius: (this.circleSize * 1.29) / 2,
      }
      const roundClass = new Round(
          round.radius,
          round.count,
          RoundDirection.RIGHT,
          baseAngle
        );
      const position = index - this.list.length / 2;
      const shift = roundClass.getCenterShift(position, round.count / 2);
      return {
        ...round,
        position,
        shift,
        baseAngle
      }
    },

    calcTransformShift(index) {
      const round = this.round(index);
      return `transform: translate(${round.shift.x + 40}px, ${round.shift.y + round.position * round.count / 4}px);`;
    },

    calcTransformSpaceLineShift(index) {
      const round = this.round(index);
      return `width: ${round.radius + 20}px; transform: rotate(${round.shift.deg * 55 + (round.baseAngle / round.count * 30)}deg);`;
    },

    calcTransformMarkLineShift(index) {
      const round = this.round(index);
      return `width: ${round.radius + 20}px; transform: rotate(${round.shift.deg * 55}deg);`;
    },
  },
  computed: {
    circleSize() {
      return this.$store.getters.circleSize;
    },
    list() {
      return this.$store.getters.getSelectedCoffeeListWithPercent;
    },
    windowWidth() {
      return this.$store.getters.windowWidth;
    },
  },
};
</script>

<style lang="scss">
$topBottomGap: 60px;
$stepHeight: 40px;

.round-sl__holder {
  position: absolute;
  left: 50%;
  overflow: hidden;
  right: 0%;
  top: 50%;
  height: 100%;
  transform: translate(0%, -50%);
}

.round-sl {
  border: 4px solid white;
  border-radius: 50%;

  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(-50%, -50%);
}

.round-sl__elements {
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
  justify-content: flex-end;

  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-100%, -100%);

  pointer-events: none;
}

.round-sl__item-holder {
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: calc(50% - #{$stepHeight / 2});

  width: 0;
  height: $stepHeight;
  line-height: 1;

  font-family: $textFont;
  font-size: 14px;
  letter-spacing: 1px;
  color: white;

  transition: all 200ms ease-in;
}

.round-sl__item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  transform: translateX(50%);
  min-width: 180px;
}

.round-sl__line {
  height: 4px;
  display: block;
  position: absolute;
  left: 0;
  height: 4px;
  transform-origin: left center;

  &--space {
    &::after {
      content: '';
      width: 20px;
      position: absolute;
      display: block;
      right: 0;
      top: 0;
      bottom: 0;

      background-color: $green;
    }
  }

  &--mark {
    &::after {
      content: '';
      width: 10px;
      position: absolute;
      display: block;
      right: -5px;
      top: 0;
      bottom: 0;

      background-color: white;
    }
  }
}

.round-sl__prcent {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  big {
    font-size: 1.8em;
    font-weight: bold;
  }

  sup {
    position: initial;
  }
}

.round-sl__name {
  position: relative;
  font-size: 1rem;
  margin-left: 5px;

  span {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: max-content;
    max-width: 150px;
  }
}

@media (max-width: 780px) {
  .round-sl__holder {
    display: none;
  }
}

@media (min-width: 780.89px) {
  .round-sl__item-holder {
    font-size: 16px;
  }
}

@media (min-width: 992.89px) {
  .round-sl__item-holder {
    font-size: 18px;

    &::after {
      right: 8px;
    }
  }

  .round-sl__line {
    &--mark {
      &::after {
        right: -7px;
      }
    }
  }
}
</style>
